import { object, string } from 'zod';

import { CHARACTER_LIMIT_EXCEEDED, IS_REQUIRED } from '@occc-app/lib/constants/validationMessages';

import { OFFER_NAME_MAX_LENGTH } from '../../../tobacco-api-offers.constants';

export const createOfferNameSchema = object({
  offerName: string({ required_error: IS_REQUIRED })
    .trim()
    .min(1, IS_REQUIRED)
    .max(OFFER_NAME_MAX_LENGTH, CHARACTER_LIMIT_EXCEEDED),
});
